import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { SerasaPersonRow } from 'src/modules/motor-credito/serasa/serasa.pf.types'

export type OcupacaoProps = {
    person: SerasaPersonRow
}

export default function Ocupacao({ person }: OcupacaoProps) {
    if (!person.identificacao.carteira_trabalho) {
        return <></>
    }
    return (
        <>
            <Divider textAlign="center">Carteira de Trabalho</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Número" value={person.identificacao.carteira_trabalho.numero} xs={3} />
                <GridItem label="Série" value={person.identificacao.carteira_trabalho.serie} xs={3} />
                <GridItem label="Dep" value={person.identificacao.carteira_trabalho.dep} xs={3} />
                <GridItem label="Escolaridade" value={person.identificacao.carteira_trabalho.escolaridade} xs={3} />
                {person.ocupacao && (
                    <>
                        <GridItem label="Cargo" value={person.ocupacao.cargo} xs={6} />
                        <GridItem label="Profissão" value={person.ocupacao.profissao} xs={6} />
                    </>
                )}
            </Grid>
        </>
    )
}
